import React from 'react';
import i18n from '../../../../../i18n';
import HelpTooltip from '../../../../../components/overlays/helpTooltip/HelpTooltip';
import Button from 'react-bootstrap/Button';
import { ActionsType } from '../../../../../types/rest/assetCatalogTypes';
import BzmIcon from '../../../../../components/icons/BzmIcon';
import _ from 'lodash';
import { getMaxActionsCount } from '../../../../../utils/bzmUserConfigUtil';
import DropdownButton from '../../../../../components/ui/dropdown/DropdownButton';
import { BlazeDropdownItem } from '../../../../../components/ui/dropdown/DropdownButton/DropdownButton';

type ProcessingActionsHeaderProps = {
  totalCount: number;
  actionCounts: { [key: string]: number };
  onDelete: () => void;
  onCreate: (actionType: ActionsType) => void;
  numberOfSelected: number;
};

const ProcessingActionsHeader = (props: ProcessingActionsHeaderProps) => {
  //Maximum number per type
  const maxNumberOfActions = getMaxActionsCount();

  const isTooManyWebHooks = _.get(props.actionCounts, 'WEBHOOK', 0) >= maxNumberOfActions;
  const webHookItem: BlazeDropdownItem = {
    content: 'Webhook',
    fnCallback: () => props.onCreate('WEBHOOK'),
    disabled: isTooManyWebHooks,
    title: isTooManyWebHooks
      ? `Maximum number of Webhooks reached. Number of Webhooks cannot exceed ${maxNumberOfActions}`
      : undefined,
  };

  const isTooManyHttpCalls = _.get(props.actionCounts, 'HTTP_CALL', 0) >= maxNumberOfActions;
  const httpCallItem: BlazeDropdownItem = {
    content: 'HTTP Call',
    fnCallback: () => props.onCreate('HTTP_CALL'),
    disabled: isTooManyHttpCalls,
    title: isTooManyHttpCalls
      ? `Maximum number of HTTP calls reached. Number of HTTP calls cannot exceed ${maxNumberOfActions}`
      : undefined,
  };

  const stateUpdateItem: BlazeDropdownItem = {
    content: 'State Update',
    fnCallback: () => props.onCreate('STATE_UPDATE'),
  };

  const dropDownMenu = [webHookItem, httpCallItem];
  dropDownMenu.push(stateUpdateItem);

  const count =
    props.numberOfSelected === 0 ? props.totalCount : `${props.numberOfSelected} of ${props.totalCount} selected`;

  return (
    <div>
      <DropdownButton
        disabled={false}
        toggleTooltip={i18n.t('transactions:processingActions.modal.addProcessingAction')}
        dropdownItems={dropDownMenu}
        innerButtonSpanClassName="icon-bzm-add"
        dropdownToggleClassName={`btn btn-primary btn-circular btn-sm float-right`}
      />

      <h4>
        {i18n.t('transactions:processingActions.title')} ({count})
        <HelpTooltip
          id={'processing-actions-help'}
          className="ml-3"
          style={{ position: 'relative', top: '3px' }}
          fontSize={22}
        />
        <Button
          variant={'link'}
          id={`qa-blk-transaction-delete`}
          className="btn btn-link btn-no-hover p-0 ml-5"
          title={i18n.t('transactions:processingActions.deleteAction')}
          onClick={() => props.onDelete()}
          disabled={props.numberOfSelected === 0}
        >
          <BzmIcon variant={'icon-bzm-delete'} className={'icon-sm'} />
          <span className="sr-only">{i18n.t('transactions:processingActions.deleteAction')}</span>
        </Button>
      </h4>
      <p dangerouslySetInnerHTML={{ __html: i18n.t('transactions:processingActions.description') }}></p>
    </div>
  );
};

export default ProcessingActionsHeader;
